
import { useState, useContext } from "react";
import Modal from "../../../components/admin/modal/ProductModel";
import { CheckCircle } from "lucide-react";
import "../../../assets/css/admin/addCategory/AddCategory.css";
import axios from "axios";
import  AppContext  from "../../../context/AppContext";

const AddCategory = ({ isOpen, onClose, onAdd, triggerRefresh }) => {
  const {baseUrl, authToken} = useContext(AppContext);

  const [formData, setFormData] = useState();
  const [errors, setErrors] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [description, setDescription] = useState("");
  


const createCategory = () =>{
  console.log("add category called");
  const formData = new FormData();
  formData.append("name",name);
  formData.append("type",type);
  formData.append("description",description);

  console.log(name);
  console.log(type);
  console.log(description);
  
  axios.post(`${baseUrl}/admin/category/createCategory`, formData,{
    headers:{
      Authorization:`Bearer ${authToken}`,
      "content-Type" : "multipart/form-data"
    }
  }).then((response) => {
    console.log(response.data); 
    triggerRefresh();  
    onClose();
     
  }).catch((error) => {
    console.log(error);

  })

}
  // ── Handlers ──
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({ ...prev, [name]: value }));
  //   if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  // };

  const validate = () => {
    const errs = {};
    if (!name.trim()) errs.name = "Category name is required.";
    if (!type) errs.type = "Please select a category type.";
    if (!description.trim())
      errs.description = "Description is required.";
    return errs;
  };

  const resetForm = () => {
    setErrors({});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }

    createCategory();

  };

  const handleClose = () => {
    if (!isSaving) {
      resetForm();
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Add New Category"
      size="medium"
    >
      {showSuccess ? (
        <div className="cat-add-success-message">
          <div className="cat-add-success-icon">
            <CheckCircle size={36} strokeWidth={1.8} />
          </div>
          <h3>Category Added Successfully!</h3>
          <p>The new category has been added to your list.</p>
        </div>
      ) : (
        <form className="cat-add-form" onSubmit={handleSubmit}>
          <div className="cat-add-form-grid">
            {/* ── Name ── */}
            <div className="cat-add-form-group cat-add-full-width">
              <label htmlFor="name">Category Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={name}
                onChange={(event)=>{
                 setName(event.target.value)
                }}
                className={errors.name ? "cat-add-error" : ""}
                placeholder="e.g. Sofas, Dining Sets"
              />
              {errors.name && (
                <span className="cat-add-error-text">{errors.name}</span>
              )}
            </div>

            {/* ── Type ── */}
            <div className="cat-add-form-group cat-add-full-width">
              <label>Category Type *</label>
              <div className="cat-add-type-group">
                {["product", "inventory"].map((t) => (
                  <label
                    key={t}
                    className={`cat-add-type-card ${type === t ? "selected" : ""} ${errors.type ? "cat-add-type-error" : ""}`}
                  >
                    <input
                      type="radio"
                      name="type"
                      value={t}
                      checked={type === t}
                      onChange={(event)=>{
                       setType(event.target.value)
                      }}
                    />
                    <span className="cat-add-type-label">
                      {t === "product" ? "Product" : "Inventory"}
                    </span>
                    <span className="cat-add-type-sub">
                      {t === "product"
                        ? "For finished goods sold to customers"
                        : "For materials used in production"}
                    </span>
                  </label>
                ))}
              </div>
              {errors.type && (
                <span className="cat-add-error-text">{errors.type}</span>
              )}
            </div>

            {/* ── Description ── */}
            <div className="cat-add-form-group cat-add-full-width">
              <label htmlFor="description">Description *</label>
              <textarea
                id="description"
                name="description"
                value={description}
                onChange={(event)=>{
                  setDescription(event.target.value)
                }}
                className={errors.description ? "cat-add-error" : ""}
                placeholder="Briefly describe this category"
                rows="3"
              />
              {errors.description && (
                <span className="cat-add-error-text">{errors.description}</span>
              )}
            </div>
          </div>

          <div className="cat-add-form-actions">
            <button
              type="button"
              className="cat-add-cancel-btn"
              onClick={handleClose}
              disabled={isSaving}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="cat-add-save-btn"
              disabled={isSaving}
            >
              {isSaving ? (
                <>
                  <span className="cat-add-spinner" /> Adding…
                </>
              ) : (
                "Add Category"
              )}
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default AddCategory;